module.exports = __webpack_public_path__ + "img/logo.f89783ac.svg";